import styled from 'styled-components';
import IamlCortesiaImg from 'assets/images/painel_new/iaml_cortesia.png';

export const Container = styled.div`
  .bg-iaml {
    background-image: url('${IamlCortesiaImg}');
    background-size: 101%;
    background-position: center;
    background-repeat: no-repeat;
  }

  .button-container {
    position: absolute;
    bottom: 16px;
  }

  .row-equal-height {
    display: flex;
    gap: 15px;
  }

  .row-equal-height > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #fff;
    border-radius: 8px;
    padding: 1.5rem;
    min-height: 250px;
    cursor: pointer;
  }
`;
